package com.vamvisions.main.portfolio.domain.model

/** The app store a [Project] is published in. */
enum class Store { GOOGLE_PLAY, APP_STORE }

/** A project's page in [store]. [url] is absolute. */
data class StoreLink(val store: Store, val url: String)
